const MuiTypography = {
  gutterBottom: {
    marginBottom: 16,
  },
}
export default MuiTypography
